import unionBy from 'lodash/unionBy'

const initialState = []

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'FETCH_SESSION_SUCCESS':
    case 'FETCH_OPENING_TIMES_SUCCESS':
      return unionBy(payload.opening_times, state, 'id')
    default:
      return state
  }
}
